

const Circles = (props)=>{
    const  {color} = props
    const {className} = props
    console.log(color)
    return(
        <div className={` ${className}`}>
                <div className={`h-[10rem] w-[10rem] absolute rounded-full -z-20 bg-[${color}] left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2 opacity-[18]  `}></div>
                <div className={`bg-[${color}] absolute opacity-[10] -z-20 rounded-full left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2   h-[20rem] w-[20rem]`}></div>
                <div className={`bg-[${color}] absolute opacity-[14] -z-20 rounded-full left-1/2 top-1/2 -translate-y-1/2 -translate-x-1/2   h-[30rem] w-[30rem]`}></div>
        </div>
    );
}

export default Circles